import { render, staticRenderFns } from "./Trackmytaxi.vue?vue&type=template&id=1d2da8e2&scoped=true&"
import script from "./Trackmytaxi.vue?vue&type=script&lang=js&"
export * from "./Trackmytaxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2da8e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
